"use client";
import PillButton from "@/app/shared/PillButton";
import AdDetailModel from "@/models/AdDetailModel";
import { Box, Typography } from "@mui/material";
import { AdActions } from "@/app/shared/ad/AdActions";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import {
  AD_DETAILS_2_COLUMN_MAX_WIDTH,
  HIDE_SCROLLBAR_STYLE,
} from "@/app/layout/LayoutConstants";

export default function AdDetailActions({
  ad,
  onContactSellerClicked,
}: {
  ad: AdDetailModel;
  onContactSellerClicked: () => void;
}) {
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        display: "flex",
        gap: 2,
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(1, 2, 2, 2),
        a: {
          color: "grey.600",
          textDecoration: "none",
        },
        overflowX: "scroll",
        ...HIDE_SCROLLBAR_STYLE,
        [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
          padding: 1,
        },
      })}
    >
      <Box
        sx={(theme) => ({
          minWidth: 0,
          display: "flex",
          gap: 2,
          [theme.breakpoints.down("md")]: {
            display: "none",
          },
        })}
      >
        {ad.gallery.items[0].preview && (
          <Box
            sx={{
              borderRadius: "100px",
              overflow: "hidden",
              width: 50,
              height: 50,
              background: `url(${ad.gallery.items[0].preview})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              flexShrink: 0,
            }}
          />
        )}

        <Box
          sx={{
            minWidth: 0,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {ad.title}
          </Typography>
          <Typography variant="body2">
            {ad.pricePrefix} {ad.price} {ad.priceSuffix}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          flexShrink: 0,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            flexWrap: "wrap",
            ".MuiButton-root": {
              backgroundColor: "grey.100",
            },
          }}
        >
          <AdActions ad={ad} compactOnMobile />
        </Box>
        {/* AJB: should put message & call here?  at least get it working */}

        {!ad.isInactive && (
          <PillButton
            sx={(theme) => ({
              display: "none",
              [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                display: "flex",
              },
            })}
            startIcon={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <PhoneIcon />
                <EmailIcon />
              </Box>
            }
            onClick={onContactSellerClicked}
            primary
            compactOnMobile
          >
            Contact
          </PillButton>
        )}
      </Box>
    </Box>
  );
}
